import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom'
import ReduxToastr from 'react-redux-toastr-custom'

import appContainer from './AppContainer'
import LoadingBar from '@modules/loading-bar/loading-bar'
import Sidebar from '@components/Sidebar/Sidebar'
import Topbar from '@components/Topbar/Topbar'
import AccessDenied from '@scenes/AccessDenied/AccessDenied'

const toastrOptions = {
  timeOut: 5000,
  icon: (<div></div>),
  newestOnTop: false,
  preventDuplicates:  false,
  position: "bottom-right",
  transitionIn: "fadeIn",
  transitionOut: "fadeOut",
  progressBar: false,
  closeOnToastrClick: false,
}

@withRouter
@appContainer
class App extends Component {

  render() {
    const {
      auth, 
      location, 
      children
    } = this.props;

    if(!auth.loggedIn)
      return <Redirect to={{ pathname: "/login", state: { from: location }}} />
    else 
      return (
        <div className="App">
          <LoadingBar/>
          <Topbar />
        	<Sidebar />
        	<div className="ContentWrap">
            <div className="inner">
          		{
                auth.unauthorized
                ? <AccessDenied />
                : children
              }
            </div>
        	</div>

          <ReduxToastr {...toastrOptions} />
        </div>
      )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/scenes/App/App.jsx